import type React from 'react'
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary'
import type { ErrorBoundaryProps } from '@/types'
import { ErrorFallback } from './error/error-fallback'
import { reportError } from '@/lib/error-utils'

export const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({
  children,
  onError,
}) => {
  const handleError = (error: unknown, errorInfo: React.ErrorInfo) => {
    reportError({
      error: error as Error,
      context: 'ErrorBoundary',
      customMessage: 'An unexpected error occurred. Please try again.',
    })
    onError?.(error as Error, errorInfo)
  }

  return (
    <ReactErrorBoundary
      fallback={
        <ErrorFallback
          error={new Error('An unexpected error occurred')}
          resetErrorBoundary={() => {
            window.location.reload()
          }}
        />
      }
      onError={handleError}
    >
      {children}
    </ReactErrorBoundary>
  )
}
